<template>
  <AccountAdmin></AccountAdmin>
</template>

<script>
// @ is an alias to /src
import AccountAdmin from '@/components/AccountAdmin.vue'

export default {
  name: 'AccountAdminView',
  components: {
    AccountAdmin
  }
}
</script>
